import { useEffect, useState } from "react";
import { Alert, Collapse, Container, Grid, IconButton, Slide, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import Header from "../../../components/layouts/Header";
import Page from "../../../components/layouts/Page";
import img from "../../../assets/headers/quisom.jpeg";
import bg from "../../../assets/fons/background_fost.jpg";
import bg2 from "../../../assets/fons/background_clar.jpg";
import alpaca from "../../../assets/img/alpaca-cap.png";
import { ReactComponent as Simbol1 } from "../../../assets/simbols/simbol3.svg";
import { useTranslation } from "react-i18next";
import ReactDatePicker from "react-datepicker";
import { ca, es } from "date-fns/locale";
import { getDate } from "date-fns";
import moment from "moment/min/moment-with-locales";
import calStyle from "../../../theme/calStyle.css";
import { Add, CalendarMonth, EmojiEmotions, Groups, Remove, ThumbUpAlt } from "@mui/icons-material";
import { createReserva, getElements } from "../../../database/API";
import Loading from "../../../components/layouts/Loading";
import svg from "../../../assets/simbols/mascara-activitats-1.svg";
import CustomButton from "../../../components/CustomButton";
import CustomTextField from "../../../components/form/CustomTextField";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "notistack";
import CustomTabs from "../../../components/form/CustomTabs";
import { diaBlock, setMaxPx } from "../../../utils";
import { useNavigate } from "react-router";

const ReservaForm = ({ admin = false, setOpen, setUpdate }) => {
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:960px)");
    const { t, i18n } = useTranslation();
    const [data, setData] = useState();
    const [adults, setAdults] = useState(0);
    const [nens, setNens] = useState(0);
    const [nadons, setNadons] = useState(0);
    const [bebes, setBebes] = useState(0);
    const [total, setTotal] = useState(0);
    const [activitats, setActivitats] = useState([]);
    const [activitat, setActivitat] = useState();
    const [loading, setLoading] = useState(true);
    const [disable, setDisable] = useState(true);
    const [preu, setPreu] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const [tab, setTab] = useState(0);
    const [animate, setAnimate] = useState(true);
    const [exclude, setExclude] = useState();
    const [dataBlock, setDataBlock] = useState([]);
    const [max, setMax] = useState(0);
    const requiredContactFields = ["nom", "cognoms", "email", "telefon"];
    const navigate = useNavigate();

    const shcemaReserva = yup.object({
        nom: yup.string().required(t("nom_ob")),
        telefon: yup.string().required(t("telefon_ob")),
        email: yup.string().email(t("email_valid")).required(t("email_ob")),
        cognoms: yup.string().required(t("cognoms_ob")),
    });

    const steps = [
        {
            nom: t("selecciona_activitat"),
            icon: EmojiEmotions,
        },
        {
            nom: t("selecciona_data"),
            icon: CalendarMonth,
        },
        {
            nom: t("persones"),
            icon: Groups,
        },
        {
            nom: t("confirmar"),
            icon: ThumbUpAlt,
        },
    ];

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
    } = useForm({
        resolver: yupResolver(shcemaReserva),
    });

    useEffect(() => {
        const getActivitats = async () => {
            const { result } = await getElements("activitats");
            const block = await getElements("data_block");
            setDataBlock(block?.result);
            setActivitats(result);
            setLoading(false);
        };
        getActivitats();
    }, []);

    useEffect(() => {
        setTotal(adults + nens + nadons);
    }, [adults, nadons, nens]);

    const renderDia = (day, date) => {
        return (
            <Box style={{ position: "relative" }}>
                <span>{getDate(date)}</span>
            </Box>
        );
    };

    useEffect(() => {
        if (!data || !activitat || Object.keys(errors).length || !adults) {
            setDisable(true);
        } else {
            setPreu(adults * Number(activitat?.preu_adult) + nens * Number(activitat?.preu_nen) + nadons * Number(activitat?.preu_nado));
            setDisable(false);
        }
    }, [activitat, adults, data, errors, nadons, nens]);

    useEffect(() => {
        data && setMax(setMaxPx(activitat?.max, activitat?.reserves, moment(data).format("YYYY-MM-DD")));
    }, [activitat, data]);

    useEffect(() => {
        if (activitat) {
            setAdults(0);
            setNens(0);
            setNadons(0);
            setBebes(0);
            setData("");
            setPreu(0);
            setExclude(activitat?.reserves);
            // setMax(setMaxPx(activitat?.max, activitat?.reserves));
        }
    }, [activitat]);

    const enviar = async (values) => {
        setLoading(true);
        values.activitat_id = activitat.id;
        values.data = moment(data).format("YYYY-MM-DD");
        values.adults = adults;
        values.nens = nens;
        values.nadons = nadons;
        values.bebes = bebes;
        values.total = total;
        values.preu = preu;
        try {
            await createReserva(values);
            enqueueSnackbar("Reserva creada", {
                variant: "success",
            });
            if (admin) {
                setOpen(false);
                setUpdate((prev) => prev + 1);
            } else {
                navigate("/reserva-ok");
            }
        } catch (error) {
            setLoading(true);
            enqueueSnackbar("Alguna cosa no ha anat bé", {
                variant: "error",
            });
        }
    };

    function disabledDate(current) {
        return (
            setMaxPx(activitat?.max, activitat?.reserves, moment(current).format("YYYY-MM-DD")) !== 0 &&
            !diaBlock(dataBlock, moment(current).format("YYYY-MM-DD"), moment(current).weekday() === 5 || moment(current).weekday() === 6)
        );
    }

    const isStepComplete = (stepIndex = tab, overrides = {}) => {
        const selectedActivitat = overrides.activitat ?? activitat;
        const selectedData = overrides.data ?? data;
        const contactValues = requiredContactFields.map((field) => overrides[field] ?? watch(field));
        const hasErrors = Object.keys(errors).length > 0;

        switch (stepIndex) {
            case 0:
                return Boolean(selectedActivitat);
            case 1:
                return Boolean(selectedData);
            case 2:
                return total > 0 && contactValues.every(Boolean) && !hasErrors;
            default:
                return true;
        }
    };

    const handleNext = (overrides = {}) => {
        if (!isStepComplete(tab, overrides)) {
            enqueueSnackbar("Omple la informació requerida abans de continuar", { variant: "warning" });
            return;
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        setAnimate(false);
        setTimeout(() => {
            setTab((prevActiveStep) => prevActiveStep + 1);
            setAnimate(true);
        }, 300);
    };

    const handleChange = (index) => {
        if (index > tab && !isStepComplete()) {
            enqueueSnackbar("Omple la informació requerida abans de continuar", { variant: "warning" });
            return;
        }
        setAnimate(false);
        setTimeout(() => {
            setTab(index);
            setAnimate(true);
        }, 300);
    };

    const renderStep = (index) => {
        switch (index) {
            case 0:
                return <SeleccionaActivitat />;
            case 1:
                return <SeleccionaData />;
            case 2:
                return <Persones />;

            case 3:
                return <Resum />;

            default:
                break;
        }
    };

    const Resum = () => {
        return (
            <Box className={classes.mainResum} position={"relative"}>
                {!admin && <Simbol1 className={matches ? classes.simbol1 : classes.simbol1_m} />}
                <Typography variant="h5">{t("resum_reserva")}</Typography>
                <Grid container spacing={3} pb={3}>
                    <Grid item md={6}>
                        <Typography variant="body1" mt={1}>
                            <strong>{t("activitat")}</strong>: {activitat?.nom}
                        </Typography>
                        <Typography variant="body1">
                            <strong>{t("data")}: </strong>
                            {data && moment(data).locale(i18n.language).format("LL")}
                        </Typography>
                        <Typography variant="body1">
                            <strong>{t("horari")}</strong>: {activitat?.horaris}
                        </Typography>
                        <Typography variant="body1">
                            <strong>{t("persones")}</strong>: {total}
                        </Typography>
                        {bebes ? (
                            <Typography variant="body1">
                                <strong>{t("nens_0_2")}</strong>: {bebes}
                            </Typography>
                        ) : (
                            ""
                        )}
                    </Grid>

                    <Grid item md={6}>
                        <Typography variant="body1" mt={1}>
                            <strong>{t("nom")}</strong>: {watch("nom")}
                        </Typography>
                        <Typography variant="body1">
                            <strong>{t("cognoms")}</strong>: {watch("cognoms")}
                        </Typography>

                        <Typography variant="body1">
                            <strong>E-mail</strong>: {watch("email")}
                        </Typography>

                        <Typography variant="body1">
                            <strong>{t("telefon")}</strong>: {watch("telefon")}
                        </Typography>

                        {watch("observacions") && (
                            <Typography variant="body1">
                                <strong>{t("observacions")}</strong>: {watch("observacions")}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Box>
                        <Typography variant="h5">
                            <strong>{t("preu")}</strong>: {preu}€
                        </Typography>
                    </Box>
                    <Box style={{ filter: `grayscale(${disable ? "90%" : "0%"})` }}>
                        <CustomButton title={"Reservar"} type="submit" disable={disable} loading={loading} />
                    </Box>
                </Box>
                <Typography variant="caption">{t("preu_pagament")}</Typography>
            </Box>
        );
    };

    const SeleccionaActivitat = () => {
        return (
            <Box textAlign={"center"}>
                <Typography variant="h5" mb={4}>
                    {t("selecciona_activitat")}
                </Typography>
                <Grid container spacing={0} mb={4}>
                    <Grid item md={2} xs={12}></Grid>
                    {activitats
                        ?.filter((a) => Number(a.reservable) === 1)
                        ?.map((act) => (
                            <Grid item md={4} xs={12} px={7} key={act.id} mb={3}>
                                <Box
                                    position={"relative"}
                                    display={"flex"}
                                    justifyContent={"center"}
                                    flexDirection={"column"}
                                    alignItems={"center"}
                                    mb={2}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setActivitat(act);
                                        handleNext({ activitat: act });
                                    }}
                                >
                                    <Box zIndex={0} className={admin ? "" : classes.imgWrap}>
                                        {act.id === activitat?.id && <Box className={classes.active} />}
                                        <img
                                            src={"https://api.merollabergueda.com/public/storage/" + act.foto}
                                            alt={i18n.language === "ca" ? act.nom : act.nom_es}
                                            className={classes.img2}
                                        />
                                    </Box>
                                    <Typography mt={1} textAlign={"center"}>
                                        <strong>{i18n.language === "ca" ? act.nom : act.nom_es}</strong>
                                    </Typography>
                                    <Typography textAlign={"center"}>{act.horaris}</Typography>
                                </Box>
                            </Grid>
                        ))}
                </Grid>
            </Box>
        );
    };

    const SeleccionaData = () => {
        return (
            <Box mb={4}>
                <Grid container spacing={2} mb={4}>
                    <Grid item md={2} xs={12}></Grid>
                    <Grid item md={8} xs={12}>
                        <Typography variant="h5">{t("selecciona_data")}</Typography>
                        <ReactDatePicker
                            onChange={(data) => {
                                setData(data);
                                handleNext({ data });
                            }}
                            selected={data ?? ""}
                            locale={i18n.language === "ca" ? ca : es}
                            dateFormat="dd/MM/yyyy"
                            renderDayContents={renderDia}
                            inline
                            minDate={moment().add(2, "days").toDate()}
                            maxDate={moment().add(2, "months").toDate()}
                            // excludeDates={exclude}
                            filterDate={disabledDate}
                            style={calStyle}
                        />
                    </Grid>
                </Grid>
            </Box>
        );
    };

    const Persones = () => {
        return (
            <Box>
                {activitat?.max > max && (
                    <Box mb={2}>
                        <Alert severity="info">
                            {t("mes_persones")}, {moment(data).locale(i18n.language).format("LL")}. {t("disponibles")}: {max} {t("persones")}
                        </Alert>
                    </Box>
                )}
                <Grid container spacing={5} mb={10}>
                    <Grid item md={6} textAlign="left">
                        <Typography variant="h5" mb={4}>
                            {t("selecciona_persones")}
                        </Typography>
                        <Selector setValue={setAdults} value={adults} label={t("adults")} max={max} total={total} />
                        {activitat?.preu_nado ? (
                            <Box>
                                <Selector setValue={setNens} value={nens} label={t("nens_7_12")} max={max} total={total} />
                                <Selector setValue={setNadons} value={nadons} label={t("nens_4_6")} max={max} total={total} />
                                <Selector setValue={setBebes} value={bebes} label={t("nens_0_3")} />
                            </Box>
                        ) : (
                            <Box>
                                <Selector setValue={setNens} value={nens} label={t("nens_2_12")} max={max} total={total} />
                                <Selector setValue={setBebes} value={bebes} label={t("nens_0_2")} />
                            </Box>
                        )}

                        <Box mt={1}>
                            {activitat?.preu_nado ? (
                                <Typography variant="caption">{t("menys_de_3")}</Typography>
                            ) : (
                                <Typography variant="caption">{t("menys_de_2")}</Typography>
                            )}
                        </Box>
                        <Typography variant="h5" mt={2}>
                            {t("total_persones")}: {total}
                        </Typography>
                        <Typography variant="caption">
                            <strong>{t("disponibles")}</strong>: {max} {t("persones")}
                        </Typography>
                    </Grid>
                    <Grid item md={6} textAlign="left">
                        <Collapse in={total}>
                            <Typography variant="h5" mb={2}>
                                {t("omple_dades")}
                            </Typography>
                            <CustomTextField name="nom" label={t("nom")} type="text" errors={errors.nom} register={register} required />
                            <CustomTextField name="cognoms" label={t("cognoms")} type="text" errors={errors.cognoms} register={register} required />
                            <CustomTextField name="email" label={"E-mail"} type="text" errors={errors.email} register={register} required />
                            <CustomTextField name="telefon" label={t("telefon")} type="text" errors={errors.telefon} register={register} required />
                            <CustomTextField
                                name="observacions"
                                label={t("observacions")}
                                type="text"
                                errors={errors.observacions}
                                register={register}
                                multiline
                                rows={5}
                            />
                        </Collapse>
                    </Grid>
                </Grid>
            </Box>
        );
    };

    return (
        <Loading loading={loading}>
            <form onSubmit={handleSubmit(enviar)}>
                <Box className={classes.main}>
                    <Container maxWidth="md" style={{ zIndex: 1 }}>
                        <Box className={classes.stepper}>
                            {steps.map((label, index) => {
                                return (
                                    <CustomTabs index={index} label={label} activeStep={tab} changeStep={handleChange} key={index} disabled={label.disabled} />
                                );
                            })}
                        </Box>
                        <Box mt={5}>
                            <Slide
                                direction={animate ? "left" : "right"}
                                in={animate}
                                style={{
                                    transformOrigin: "0",
                                }}
                            >
                                <div>{renderStep(tab)}</div>
                            </Slide>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                }}
                            ></Box>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                            {Number(tab) < steps.length - 1 && (
                                <CustomButton onClick={() => handleNext()} variant="contained" title={t("seguent_pas")} disable={!isStepComplete()} />
                            )}
                        </Box>
                    </Container>

                    {!admin && matches && <img src={alpaca} alt="Merolla de Berguedà" className={classes.alpaca} />}
                </Box>
            </form>
        </Loading>
    );
};

const Reserves = () => {
    const { t } = useTranslation();
    return (
        <Page title={t("Merolla de Berguedà - " + t("reserves"))}>
            <Header title={t("reserves")} img={img} />
            <ReservaForm />
        </Page>
    );
};

const Selector = ({ setValue, value, max = 10, label, total = 0 }) => {
    const classes = useStyles();

    return (
        <Box className={classes.seleccioPersona} mt={2}>
            <Typography variant="h6" fontSize={20}>
                {label}
            </Typography>
            <Box display={"flex"} width={"100%"} justifyContent={"space-between"}>
                <IconButton onClick={() => setValue((prev) => (prev > 0 ? prev - 1 : 0))}>
                    <Remove />
                </IconButton>
                <Typography variant="h5">{value}</Typography>

                <IconButton onClick={() => setValue((prev) => (total < max ? prev + 1 : prev))}>
                    <Add />
                </IconButton>
            </Box>
        </Box>
    );
};

export { Reserves, ReservaForm };

const useStyles = makeStyles((theme) => ({
    main: {
        background: `url(${bg})`,
        display: "flex",
        paddingTop: 100,
        paddingBottom: 100,
        flexDirection: "column",
        position: "relative",
    },
    stepper: {
        transition: "0.5s",
        overflowX: "scroll",
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        zIndex: 1000,
    },
    main_m: {
        height: 700,
        background: `url(${bg})`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "hidden",
    },
    main2: {
        background: `url(${bg2})`,
        display: "flex",
        paddingTop: 200,
        paddingBottom: 200,
        flexDirection: "column",
        position: "relative",
    },
    img: {
        width: "100%",
        maxWidth: 400,
        zIndex: 0,
    },
    simbol1: {
        width: 60,
        fill: theme.color.secondary,
        position: "absolute",
        left: -30,
        top: 20,
        transform: "rotate(-10deg)",
    },
    simbol2: {
        width: 50,
        fill: theme.color.primary,
        position: "absolute",
        right: 90,
        top: "32%",
        transform: "scaleX(-1)",
    },
    simbol1_m: {
        width: 60,
        fill: theme.color.secondary,
        position: "absolute",
        left: 0,
        top: -30,
        transform: "rotate(-10deg)",
    },
    alpaca: {
        position: "absolute",
        width: 400,
        left: 0,
        top: 0,
    },

    alpaca2: {
        position: "absolute",
        width: 400,
        right: 0,
        bottom: 0,
    },
    mainResum: {
        padding: 30,
        background: `url(${bg2})`,
        marginBottom: 80,
        justifyContent: "space-between",
        borderRadius: 30,
    },
    seleccioPersona: {
        padding: 10,
        background: `url(${bg2})`,

        borderRadius: 15,
    },
    imgWrap: {
        height: 189,
        width: "100%",
        position: "relative",
        mask: `url(${svg})`,
        maskSize: "cover",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        transition: "0.2s",
        "&:hover": {
            transform: "scale(1.05)",
        },
        [theme.breakpoints.down("sm")]: {
            height: 265,
        },
    },
    active: {
        backgroundColor: "#73c77357",
        position: "absolute",
        top: 0,
        height: 189,
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            height: 265,
        },
    },
    img2: {
        objectFit: "cover",
        height: 189,
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            height: 265,
        },
    },
}));
